@if (
  CompanyVendor &&
  (ComplianceSetting || BusinessComplianceSetting) &&
  ComplianceProgress !== undefined
) {
  <!-- No outer `container-fluid p-0` — the global rule in core.less
       applies 32px padding to the first container-fluid inside a routed
       component, which would make these cards 64px narrower than the
       shared compliance-info card above. The wizard shell already
       provides the column chrome, so a plain div is enough. -->
  <div class="compliance-review-body">
    <div class="business-section">
      <app-display-card>
        <div class="business-section-head">
          <h3 class="mb-0">Company background check</h3>
          <div class="action-row">
            @if (RequestJobs.length > 0) {
              <button
                type="button"
                class="btn btn-ghost btn-sm"
                (click)="resetStuckVerification()"
              >
                Reset stuck verification
              </button>
            }
            @if (
              Vendor && (Vendor.BusinessVerificationApiErrors?.length ?? 0 > 0)
            ) {
              <button
                type="button"
                class="btn btn-ghost btn-sm"
                (click)="clearBusinessVerificationErrors()"
              >
                Clear errors
              </button>
            }
            @if (hasBusinessReportData && CompanyVendor.country === 'US') {
              <button
                type="button"
                class="btn btn-outline btn-sm"
                (click)="downloadRawDataReports()"
              >
                <i class="bi bi-download me-1"></i>
                Raw data
              </button>
              <button
                type="button"
                class="btn btn-outline btn-sm"
                (click)="downloadBusinessVerificationReport()"
              >
                <i class="bi bi-download me-1"></i>
                Report
              </button>
            }
            <button
              type="button"
              class="btn btn-outline btn-sm"
              (click)="runBusinessVerification()"
            >
              <i class="bi bi-shield-check me-1"></i>
              Run public data
            </button>
          </div>
        </div>

        <dl class="business-meta">
          <div class="business-meta__row">
            <dt>Findings last updated</dt>
            <dd>
              {{
                ((CompanyVendor.isUsingNewBusinessVerification
                  ? $safeNavigationMigration(
                      CompanyVendor.Vendor?.ComplianceFinding
                        ?.v2BusinessVerificationUpdatedAt
                    )
                  : $safeNavigationMigration(
                      CompanyVendor.Vendor?.ComplianceFinding
                        ?.legacyBusinessVerificationUpdatedAt
                    )
                ) | date: 'MM/dd/y') || '—'
              }}
            </dd>
          </div>
          <div class="business-meta__row">
            <dt>Last run date</dt>
            <dd>
              {{
                (Vendor.lastRanBusinessVerificationReportDate
                  | date: 'MM/dd/y') || '—'
              }}
            </dd>
          </div>
        </dl>

        @if (isRunningBusinessVerification) {
          <div class="business-warning">
            <i class="bi bi-info-circle business-warning__icon"></i>
            <span>
              Business verification is running on this vendor. Please check back
              in a few minutes.
            </span>
          </div>
        }
        <form [formGroup]="ComplianceFindingForm">
          @if (
            CompanyVendor.isUsingNewBusinessVerification &&
            BusinessComplianceSetting &&
            NewBusinessInfoResults &&
            CompanyVendor.country === 'US'
          ) {
            <div class="inner-panel rounded">
              <div class="b-findings__head">
                <div class="b-findings__col">
                  <label>Check</label>
                </div>
                <div class="b-findings__col">
                  <label>Finding</label>
                </div>
                <div class="b-findings__col">
                  <label>Level: {{ vendorRiskLevel || 'Global' }}</label>
                </div>
                <div class="b-findings__col">
                  <label>Result</label>
                </div>
              </div>
              @if (
                !checkIfNullOrUndefined(
                  BusinessComplianceSetting.secretaryOfState
                ) &&
                !isNotRequiredResult(
                  NewBusinessInfoResults.secretaryOfStateResults
                )
              ) {
                <div class="b-findings__row">
                  <div class="b-findings__col">
                    <label>Secretary of State</label>
                  </div>
                  <div class="b-findings__col">
                    <select
                      class="form-select"
                      formControlName="companySecretaryOfState"
                    >
                      @for (
                        secretaryOfStateObject of secretaryOfStateValues;
                        track secretaryOfStateObject
                      ) {
                        <option [ngValue]="secretaryOfStateObject.value">
                          {{ secretaryOfStateObject.label }}
                        </option>
                      }
                    </select>
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label>{{
                      BusinessComplianceSetting.secretaryOfState ? 'Yes' : 'No'
                    }}</label>
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label appStatusStyleChanges>{{
                      NewBusinessInfoResults.secretaryOfStateResults
                    }}</label>
                  </div>
                </div>
              }
              @if (
                !checkIfNullOrUndefined(
                  BusinessComplianceSetting.businessVerified
                ) &&
                !isNotRequiredResult(
                  NewBusinessInfoResults.businessVerifiedResults
                )
              ) {
                <div class="b-findings__row">
                  <div class="b-findings__col">
                    <label>Business Name & Tax ID Verified</label>
                  </div>
                  <div class="b-findings__col">
                    <select
                      class="form-select"
                      formControlName="companyBusinessVerified"
                    >
                      @for (yesNoObject of yesNoValues; track yesNoObject) {
                        <option [ngValue]="yesNoObject.value">
                          {{ yesNoObject.label }}
                        </option>
                      }
                    </select>
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label>{{
                      BusinessComplianceSetting.businessVerified ? 'Yes' : 'No'
                    }}</label>
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label appStatusStyleChanges>{{
                      NewBusinessInfoResults.businessVerifiedResults
                    }}</label>
                  </div>
                </div>
              }
              @if (
                !checkIfNullOrUndefined(
                  BusinessComplianceSetting.governmentWatchlist
                ) &&
                !isNotRequiredResult(
                  NewBusinessInfoResults.governmentWatchlistResults
                )
              ) {
                <div class="b-findings__row">
                  <div class="b-findings__col">
                    <label>Government Watchlist</label>
                  </div>
                  <div class="b-findings__col">
                    <select
                      class="form-select"
                      formControlName="companyGovernmentWatchlist"
                    >
                      @for (
                        watchlistObject of watchlistValues;
                        track watchlistObject
                      ) {
                        <option [ngValue]="watchlistObject.value">
                          {{ watchlistObject.label }}
                        </option>
                      }
                    </select>
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label>{{
                      getNewWatchlistRequirementLabel(
                        BusinessComplianceSetting.governmentWatchlist!
                      )
                    }}</label>
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label appStatusStyleChanges>{{
                      NewBusinessInfoResults.governmentWatchlistResults
                    }}</label>
                  </div>
                </div>
              }
              @if (
                !checkIfNullOrUndefined(BusinessComplianceSetting.liens) &&
                !isNotRequiredResult(NewBusinessInfoResults.lienResults)
              ) {
                <div class="b-findings__row">
                  <div class="b-findings__col">
                    <label>Company Liens & Judgements</label>
                  </div>
                  <div class="b-findings__col">
                    <input
                      type="text"
                      class="form-control"
                      formControlName="companyLiensAndJudgments"
                    />
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label>{{
                      getCorporateLiensLabel(BusinessComplianceSetting.liens!)
                    }}</label>
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label appStatusStyleChanges>{{
                      NewBusinessInfoResults.lienResults
                    }}</label>
                  </div>
                </div>
              }
              @if (
                !checkIfNullOrUndefined(BusinessComplianceSetting.liens) &&
                !isNotRequiredResult(NewBusinessInfoResults.lienResults)
              ) {
                <div class="b-findings__row">
                  <div class="b-findings__col">
                    <label>Company Bankruptcies</label>
                  </div>
                  <div class="b-findings__col">
                    <select
                      class="form-select"
                      formControlName="companyBankruptcy"
                    >
                      @for (
                        bankruptcyObject of bankruptcyValues;
                        track bankruptcyObject
                      ) {
                        <option [ngValue]="bankruptcyObject.value">
                          {{ bankruptcyObject.label }}
                        </option>
                      }
                    </select>
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label>{{
                      getBankruptcyRequirementLabel(
                        BusinessComplianceSetting.bankruptcy!
                      )
                    }}</label>
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label appStatusStyleChanges>{{
                      NewBusinessInfoResults.bankruptcyResults
                    }}</label>
                  </div>
                </div>
              }
              @if (
                !checkIfNullOrUndefined(BusinessComplianceSetting.address) &&
                !isNotRequiredResult(NewBusinessInfoResults.addressResults)
              ) {
                <div class="b-findings__row">
                  <div class="b-findings__col">
                    <label>Address</label>
                  </div>
                  <div class="b-findings__col">
                    <select
                      class="form-select"
                      formControlName="companyAddress"
                    >
                      @for (
                        addressObject of addressValues;
                        track addressObject
                      ) {
                        <option [ngValue]="addressObject.value">
                          {{ addressObject.label }}
                        </option>
                      }
                    </select>
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label>{{ BusinessComplianceSetting.address }}</label>
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label appStatusStyleChanges>{{
                      NewBusinessInfoResults.addressResults
                    }}</label>
                  </div>
                </div>
              }
              @if (
                !checkIfNullOrUndefined(
                  BusinessComplianceSetting.isW9Checked
                ) && !isNotRequiredResult(NewBusinessInfoResults.w9Results)
              ) {
                <div class="b-findings__row">
                  <div class="b-findings__col">
                    <label>W9 Accepted?</label>
                  </div>
                  <div class="b-findings__col">
                    <select
                      class="form-select"
                      formControlName="companyW9Check"
                    >
                      @for (yesNoObject of yesNoValues; track yesNoObject) {
                        <option [ngValue]="yesNoObject.value">
                          {{ yesNoObject.label }}
                        </option>
                      }
                    </select>
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label>{{
                      BusinessComplianceSetting.isW9Checked ? 'Yes' : 'No'
                    }}</label>
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label appStatusStyleChanges>{{
                      NewBusinessInfoResults.w9Results
                    }}</label>
                  </div>
                </div>
              }
            </div>
          }
          @if (
            !CompanyVendor.isUsingNewBusinessVerification &&
            ComplianceSetting &&
            BusinessInfoResults &&
            CompanyVendor.country === 'US'
          ) {
            <div class="inner-panel rounded">
              <div class="b-findings__head">
                <div class="b-findings__col">
                  <label>Check</label>
                </div>
                <div class="b-findings__col">
                  <label>Finding</label>
                </div>
                <div class="b-findings__col">
                  <label
                    >Level:
                    {{ vendorRiskLevel ? vendorRiskLevel : 'Global' }}</label
                  >
                </div>
                <div class="b-findings__col">
                  <label>Result</label>
                </div>
              </div>
              @if (
                !isNotRequiredResult(BusinessInfoResults.companyInGoodStanding)
              ) {
                <div class="b-findings__row">
                  <div class="b-findings__col">
                    <label>Corporation In Good Standing</label>
                  </div>
                  <div class="b-findings__col">
                    <select
                      class="form-select"
                      formControlName="companyInGoodStanding"
                    >
                      @for (yesNoObject of yesNoValues; track yesNoObject) {
                        <option [ngValue]="yesNoObject.value">
                          {{ yesNoObject.label }}
                        </option>
                      }
                    </select>
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label>{{
                      ComplianceSetting.companyInGoodStanding ? 'Yes' : 'No'
                    }}</label>
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label appStatusStyleChanges>{{
                      BusinessInfoResults.companyInGoodStanding
                    }}</label>
                  </div>
                </div>
              }
              @if (!isNotRequiredResult(BusinessInfoResults.companyIdentity)) {
                <div class="b-findings__row">
                  <div class="b-findings__col">
                    <label>Corporate Identity Check</label>
                  </div>
                  <div class="b-findings__col">
                    <select
                      class="form-select"
                      formControlName="companyIdentity"
                    >
                      @for (
                        identityObject of identityValues;
                        track identityObject
                      ) {
                        <option [ngValue]="identityObject.value">
                          {{ identityObject.label }}
                        </option>
                      }
                    </select>
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label>{{ ComplianceSetting.companyIdentity }}</label>
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label appStatusStyleChanges>{{
                      BusinessInfoResults.companyIdentity
                    }}</label>
                  </div>
                </div>
              }
              @if (!isNotRequiredResult(BusinessInfoResults.companyWatchlist)) {
                <div class="b-findings__row">
                  <div class="b-findings__col">
                    <label>Corporate Watchlist</label>
                  </div>
                  <div class="b-findings__col">
                    <select
                      class="form-select"
                      formControlName="companyWatchlist"
                    >
                      @for (
                        watchlistObject of watchlistValues;
                        track watchlistObject
                      ) {
                        <option [ngValue]="watchlistObject.value">
                          {{ watchlistObject.label }}
                        </option>
                      }
                    </select>
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label>{{
                      getWatchlistRequirementLabel(
                        ComplianceSetting.companyWatchlist!
                      )
                    }}</label>
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label appStatusStyleChanges>{{
                      BusinessInfoResults.companyWatchlist
                    }}</label>
                  </div>
                </div>
              }
              @if (!isNotRequiredResult(BusinessInfoResults.bankruptcy)) {
                <div class="b-findings__row">
                  <div class="b-findings__col">
                    <label>Corporate Bankruptcy Search</label>
                  </div>
                  <div class="b-findings__col">
                    <select class="form-select" formControlName="bankruptcy">
                      @for (
                        bankruptcyObject of bankruptcyValues;
                        track bankruptcyObject
                      ) {
                        <option [ngValue]="bankruptcyObject.value">
                          {{ bankruptcyObject.label }}
                        </option>
                      }
                    </select>
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label>{{
                      getBankruptcyRequirementLabel(
                        ComplianceSetting.bankruptcy!
                      )
                    }}</label>
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label appStatusStyleChanges>{{
                      BusinessInfoResults.bankruptcy
                    }}</label>
                  </div>
                </div>
              }
              @if (!isNotRequiredResult(BusinessInfoResults.companyLiens)) {
                <div class="b-findings__row">
                  <div class="b-findings__col">
                    <label>Corporate Liens & Judgements</label>
                  </div>
                  <div class="b-findings__col">
                    <input
                      type="text"
                      class="form-control"
                      formControlName="companyLiens"
                    />
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label>{{
                      getCorporateLiensLabel(ComplianceSetting.companyLiens!)
                    }}</label>
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label appStatusStyleChanges>{{
                      BusinessInfoResults.companyLiens
                    }}</label>
                  </div>
                </div>
              }
              @if (!isNotRequiredResult(BusinessInfoResults.w9Check)) {
                <div class="b-findings__row">
                  <div class="b-findings__col">
                    <label>W-9 Check</label>
                  </div>
                  <div class="b-findings__col">
                    <select class="form-select" formControlName="w9Check">
                      @for (yesNoObject of yesNoValues; track yesNoObject) {
                        <option [ngValue]="yesNoObject.value">
                          {{ yesNoObject.label }}
                        </option>
                      }
                    </select>
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label>{{
                      ComplianceSetting.isW9Checked ? 'Yes' : 'No'
                    }}</label>
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label appStatusStyleChanges>{{
                      BusinessInfoResults.w9Check
                    }}</label>
                  </div>
                </div>
              }
            </div>
          }
          @if (
            !CompanyVendor.isUsingNewBusinessVerification &&
            ComplianceSetting &&
            BusinessInfoResults &&
            CompanyVendor.country === 'CA'
          ) {
            <div class="inner-panel rounded">
              <div class="b-findings__head">
                <div class="b-findings__col">
                  <label>Check</label>
                </div>
                <div class="b-findings__col">
                  <label>Finding</label>
                </div>
                <div class="b-findings__col">
                  <label
                    >Level:
                    {{ vendorRiskLevel ? vendorRiskLevel : 'Global' }}</label
                  >
                </div>
                <div class="b-findings__col">
                  <label>Result</label>
                </div>
              </div>
              @if (!isNotRequiredResult(BusinessInfoResults.companyIdentity)) {
                <div class="b-findings__row">
                  <div class="b-findings__col">
                    <label>Business Name & GST/HST Verified</label>
                  </div>
                  <div class="b-findings__col">
                    <select
                      class="form-select"
                      formControlName="companyIdentity"
                    >
                      @for (
                        identityObject of canadianIdentityValues;
                        track identityObject
                      ) {
                        <option [ngValue]="identityObject.value">
                          {{ identityObject.label }}
                        </option>
                      }
                    </select>
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label>{{
                      ComplianceSetting.companyIdentity ? 'Yes' : 'No'
                    }}</label>
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label appStatusStyleChanges>{{
                      BusinessInfoResults.companyIdentity
                    }}</label>
                  </div>
                </div>
              }
              @if (
                !isNotRequiredResult(BusinessInfoResults.companyInGoodStanding)
              ) {
                <div class="b-findings__row">
                  <div class="b-findings__col">
                    <label>Corporation In Good Standing</label>
                  </div>
                  <div class="b-findings__col">
                    <select
                      class="form-select"
                      formControlName="companyInGoodStanding"
                    >
                      @for (
                        identityObject of yesNoValues;
                        track identityObject
                      ) {
                        <option [ngValue]="identityObject.value">
                          {{ identityObject.label }}
                        </option>
                      }
                    </select>
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label>{{
                      ComplianceSetting.companyInGoodStanding ? 'Yes' : 'No'
                    }}</label>
                  </div>
                  <div class="b-findings__col b-findings__col--center">
                    <label appStatusStyleChanges>{{
                      BusinessInfoResults.companyInGoodStanding
                    }}</label>
                  </div>
                </div>
              }
            </div>
          }
        </form>
        <div class="action-row justify-end mt-3">
          <button
            type="button"
            class="btn btn-primary"
            (click)="overrideComplianceFindings()"
          >
            Save findings
          </button>
        </div>
      </app-display-card>
    </div>
    <!-- Business review info -->
    <div class="business-section">
      <app-display-card>
        <div class="business-section-head">
          <h3 class="mb-0">Business review info</h3>
          <button
            type="button"
            class="btn btn-outline btn-sm"
            (click)="editVendorInformation()"
          >
            <i class="bi bi-pencil-square me-1"></i>
            Edit info
          </button>
        </div>

        <div class="business-info-grid">
          <!-- Left column: company facts -->
          <dl class="cv-info">
            <div class="cv-info__row">
              <dt>Company legal name</dt>
              <dd>{{ Vendor.legalName }}</dd>
            </div>
            <div class="cv-info__row">
              <dt>Company DBA</dt>
              <dd>{{ Vendor.dba || '—' }}</dd>
            </div>
            <div class="cv-info__row">
              <dt>Supplier only</dt>
              <dd>{{ Vendor.isSupplier ? 'Yes' : 'No' }}</dd>
            </div>
            <div class="cv-info__row">
              <dt>Professional trade</dt>
              <dd>{{ Vendor.hasProfessionalTrade ? 'Yes' : 'No' }}</dd>
            </div>
            <div class="cv-info__row">
              <dt>Company structure</dt>
              <dd>{{ Vendor.companyType || '—' }}</dd>
            </div>
            <div class="cv-info__row">
              <dt>Tax ID</dt>
              <dd>
                @if (CompanyVendor.country === 'CA') {
                  <span
                    >{{ LocalizationInfo.taxId('gst-hst').label }}:
                    {{ Vendor.bsn }}</span
                  >
                } @else {
                  @if (!Vendor.hasSSN) {
                    <span>EIN: {{ Vendor.ein }}</span>
                  }
                  @if (maskedSSN) {
                    <span>SSN: {{ maskedSSN }}</span>
                  }
                  @if (fullSSN) {
                    <span>SSN: {{ fullSSN }}</span>
                  }
                  @if (!hasSSNAccess && !Vendor.ein) {
                    <span>SSN: ***-**-****</span>
                  }
                  @if (
                    Vendor.hasSSN && hasSSNAccess && !maskedSSN && !fullSSN
                  ) {
                    <button
                      type="button"
                      class="btn btn-ghost btn-sm p-0"
                      (click)="viewSSN()"
                    >
                      View SSN
                    </button>
                  }
                }
              </dd>
            </div>
            <div class="cv-info__row">
              <dt>Established</dt>
              <dd>{{ Vendor.yearEstablished || '—' }}</dd>
            </div>
            <div class="cv-info__row">
              <dt>Employees</dt>
              <dd>{{ getNumberOfEmployeesLabel(Vendor.qtyEmployees!) }}</dd>
            </div>
            <div class="cv-info__row">
              <dt>Employs subcontractors</dt>
              <dd>{{ Vendor.employsSubContractors ? 'Yes' : 'No' }}</dd>
            </div>
            <div class="cv-info__row">
              <dt>Publicly traded</dt>
              <dd>{{ Vendor.isPubliclyTraded ? 'Yes' : 'No' }}</dd>
            </div>
            <div class="cv-info__row">
              <dt>Company phone</dt>
              <dd>{{ Vendor.phone || '—' }}</dd>
            </div>
          </dl>

          <!-- Right column: contact + addresses -->
          <dl class="cv-info">
            @if (ComplianceContact) {
              <div class="cv-info__row">
                <dt>Primary contact</dt>
                <dd>
                  {{ ComplianceContact.firstName }}
                  {{ ComplianceContact.lastName }}
                </dd>
              </div>
              <div class="cv-info__row">
                <dt>Phone</dt>
                <dd>{{ ComplianceContact.phone1 || '—' }}</dd>
              </div>
              @if (ComplianceContact.email) {
                <div class="cv-info__row">
                  <dt>Email</dt>
                  <dd>
                    <a
                      href="mailto:{{ ComplianceContact.email }}"
                      class="email-link"
                      >{{ ComplianceContact.email }}</a
                    >
                  </dd>
                </div>
              }
            }
            <div class="cv-info__row cv-info__row--separator">
              <dt>Street address</dt>
              <dd>
                {{ StreetAddress.address1 }}
                {{ StreetAddress.address2 || '' }}, {{ StreetAddress.city }}
                {{ StreetAddress.state }}
                {{ StreetAddress.zip }}
              </dd>
            </div>
            <div class="cv-info__row">
              <dt>Mailing address</dt>
              <dd>
                {{ MailingAddress.address1 }}
                {{ MailingAddress.address2 || '' }}, {{ MailingAddress.city }}
                {{ MailingAddress.state }}
                {{ MailingAddress.zip }}
              </dd>
            </div>
          </dl>
        </div>
      </app-display-card>
    </div>

    <!-- Accounting (AP) links — if any -->
    @if (hasApVendor) {
      <div class="business-section">
        <app-display-card>
          <div class="business-section-head">
            <h3 class="mb-0">Accounting links</h3>
          </div>
          <div class="ap-vendor-list">
            @for (ApConfig of ApConfigs; track ApConfig) {
              @if (ApConfig.ApVendors) {
                @for (ApVendor of ApConfig.ApVendors; track ApVendor) {
                  <div class="ap-vendor-card">
                    <div class="ap-vendor-card__head">
                      <span class="ap-vendor-card__system">
                        {{ ApConfig.apSystem }}
                      </span>
                      <span class="cv-info__chip">
                        {{ ApVendor.vendorKey }}
                      </span>
                    </div>
                    <dl class="cv-info">
                      <div class="cv-info__row">
                        <dt>AP legal name</dt>
                        <dd>{{ ApVendor.legalName || '—' }}</dd>
                      </div>
                      <div class="cv-info__row">
                        <dt>AP DBA</dt>
                        <dd>{{ ApVendor.dba || '—' }}</dd>
                      </div>
                    </dl>
                  </div>
                }
              }
            }
          </div>
        </app-display-card>
      </div>
    }
  </div>
}
